import { useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';

import { useAccount } from './useAccount';

export const useIsImpersonatingUser = () => {
  const accountQuery = useAccount();
  const { isLoading, data: account } = accountQuery;
  const accessToken = account?.token?.access;

  const isImpersonatingUser = useMemo(() => {
    if (isLoading) {
      return undefined;
    }
    const decoded = accessToken
      ? jwtDecode<{
          email: string;
          imp_id?: number;
          exp: number;
          iat: number;
          id: number;
          organization_id: number;
        }>(accessToken)
      : undefined;
    return !!decoded?.imp_id && decoded.imp_id !== account?.user.id;
  }, [isLoading, accessToken, account?.user.id]);
  return {
    ...accountQuery,
    data: isImpersonatingUser,
  };
};
